// extracted by mini-css-extract-plugin
export var actions = "_s4-4";
export var item = "_s4-1";
export var price = "_s4-3";
export var quantity = "_s4-2";
export var table = "_s4-0";